import clsx from 'clsx';
import { CloseButton } from '../CloseButton/CloseButton';
import styles from './PillButton.css';

interface PillButtonProps {
	label: string;
	testId: string;
	customClass?: string;
	onClick?: () => void;
	isSelected?: boolean;
	isDisabled?: boolean;
	showCross?: boolean;
	onCrossClick?: () => void;
}

const PillButton = (props: Readonly<PillButtonProps>) => {
	const { label, testId, customClass, onClick, isSelected, isDisabled, showCross, onCrossClick = () => {} } = props;

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		if (!onClick) return;
		onClick();
	};

	return (
		<button
			className={clsx(styles.root, customClass, { [styles.isSelected]: isSelected || showCross })}
			disabled={isDisabled}
			data-testid={testId}
			onClick={handleClick}
		>
			<span className={styles.content}>
				{showCross && <CloseButton testId={`${label}-cross-id`} onClick={onCrossClick} iconClass={styles.cross} />}
				{label}
			</span>
		</button>
	);
};

export { PillButton };
